import React from "react";

import Button, { ButtonProps } from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

type Props = { isLoading?: boolean } & ButtonProps;

const LoadingButton = ({ children, disabled, isLoading, ...rest }: Props) => (
  <Button disabled={disabled || isLoading} {...rest}>
    {!isLoading && children}
    {isLoading && <CircularProgress color="primary" size={20} />}
  </Button>
);

export default LoadingButton;
